// extracted by mini-css-extract-plugin
export default {"p_tye":"_6f44561531","slcted":"_92717e773f","slc_color":"cebfc7186e","item_p":"_1d5f3c489a","r0":"_8ef30ef085"};